<template>
  <div class="LightGallery">
    <slot/>
  </div>
</template>

<script>
import 'lightgallery.js'
import 'lg-zoom.js'

/**
 * @module LightGallery
 */
export default {
  name: 'LightGallery',
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      defaults: {
        download: false
      }
    }
  },
  mounted () {
    window.lightGallery(this.$el, {
      ...this.defaults,
      ...this.options
    })
  },
  beforeDestroy () {
    this.cleanup()
  },
  methods: {
    cleanup () {
      const currentLightGalleryInstance = this.$el.getAttribute('lg-uid')
      if (currentLightGalleryInstance) {
        window.lgData[currentLightGalleryInstance].destroy(true)
      }
    }
  }
}
</script>

<style lang='scss'>
@import '~utils';

$lg-path-fonts: "/fonts";
$lg-path-images: '/images/light-gallery';
$zindex-outer: 2250;
$zindex-progressbar: 2283;
$zindex-controls: 2280;
$zindex-toolbar: 2282;
$zindex-subhtml: 2280;
$zindex-thumbnail: 2280;
$zindex-pager: 2280;
$zindex-playbutton: 2280;
$zindex-item: 2260;
$zindex-backdrop: 2240;

@import '~lightgallery.js/src/sass/lightgallery.scss';

</style>
